import React from 'react';
import Navbar from '../Shared/Navbar/Navbar';
import Footer from '../Shared/Footer/Footer';
import CareerDetails from './CareerDetails/CareerDetails';
import Apply from './Apply/Apply';
import { Helmet } from 'react-helmet';

const Career = () => {
    return (
        <div>
            <Helmet>
                <title>Career | Biotech</title>
            </Helmet>
            <Navbar />
            <CareerDetails />
            <Apply />
            <Footer />
        </div>
    );
};

export default Career;